import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {host} from '../../function/api'

const initialState = {
    statusList:[],
    loading: false,
    success: false,
    status: false,
    message: '',
    errorTitle: ''
}

export const statusManagmentStore = createAsyncThunk(
    'status/managment/store',
    async(data, thunckAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}statusPermission`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'Access-Control-Allow-Origin': "*",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch(error) {
            return thunckAPI.rejectWithValue(error)
        }
    }
);
export const fetchStatusUser = createAsyncThunk(
    'fetch/statusUserPermission',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}statusPermission/user`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const statusManagmentSlice = createSlice({
    name: 'statusManagment',
    initialState,
    reducers: {

    },
    extraReducers: {
        [statusManagmentStore.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.status = true
            state.message = payload.message
        },
        [statusManagmentStore.pending] : (state) => {
            state.loading = true    
            state.success = false
            state.status = false
        },
        [statusManagmentStore.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            state.status = false
            // if(payload.response.data.error) {
            //     state.errorTitle = payload.response.data.error.title
            //     state.errorstatuss = payload.response.data.error.store_id
            // }else if(payload.response.data.message) {
            //     state.message = payload.response.data.message
            // }
            
        },
        [fetchStatusUser.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = action.payload.status
            state.statusList = action.payload.data
        },
        [fetchStatusUser.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
            state.statusList = []
        },
        [fetchStatusUser.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = false
            if(payload.response.data.error){
                state.errorProfile = payload.response.data.errorProfile
                state.errorPermission = payload.response.data.permission
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
});

export const {} = statusManagmentSlice.actions;
export default statusManagmentSlice.reducer;